import { render, staticRenderFns } from "./ContactForTeamPlan.vue?vue&type=template&id=196cb830&scoped=true&"
import script from "./ContactForTeamPlan.vue?vue&type=script&lang=js&"
export * from "./ContactForTeamPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196cb830",
  null
  
)

export default component.exports